import { types } from 'mobx-state-tree'

export const JurisdictionModel = types.model('JurisdictionModel', {
  id: types.maybeNull(types.number),
  name: types.maybeNull(types.string),
  alpha2: types.maybeNull(types.string),
  alpha3: types.maybeNull(types.string),
  countryCode: types.maybeNull(types.string),
  iso_3166_2: types.maybeNull(types.string),
  logo: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  descriptionParser: types.maybeNull(types.string),
})

const AdminTeamAthleteModel = types.model('AdminTeamAthleteModel', {
  id: types.maybeNull(types.number),
  dateOfBirth: types.maybeNull(types.string),
  logo: types.maybeNull(types.string),
  sport: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  surname: types.maybeNull(types.string),
  nationality: types.maybeNull(types.string),
  isAddedToTeam: types.optional(types.boolean, true),
})

export const AdminTeamAthletesModel = types
  .model('AdminTeamAthletesModel', {
    content: types.maybeNull(
      types.optional(types.array(AdminTeamAthleteModel), [])
    ),
    page: types.optional(types.number, 0),
    size: types.optional(types.number, 0),
    totalPages: types.optional(types.number, 1),
    sportType: types.optional(types.string, ''),
    name: types.optional(types.string, ''),
  })
  .preProcessSnapshot((snapshot) => ({
    ...snapshot,
  }))

export const AdminTeamModel = types
  .model('AdminTeamsModel', {
    id: types.maybeNull(types.number),
    teamName: types.maybeNull(types.string),
    logo: types.maybeNull(types.string),
    sport: types.maybeNull(types.string),
    league: types.maybeNull(types.string),
    teamWebsite: types.maybeNull(types.string),
    jurisdiction: types.maybeNull(types.optional(JurisdictionModel, {})),
  })
  .preProcessSnapshot((snapshot) => ({
    ...snapshot,
  }))
